import { ChangeEvent, useMemo } from 'react'
import { formatUTCDate } from 'utils/formatDatetime'
import { DISPLAY } from 'constants/display'

const key = (id: string) => id.split('-')[1]

const useHandlers = (type: string, onChange: (...args: any[]) => any, contactInfo: any) =>
  useMemo(
    () => ({
      onCheckboxChange: ({ target: { checked, id } }: ChangeEvent<HTMLInputElement>) => {
        onChange(
          {
            [key(id)]: checked,
          },
          type
        )
      },

      onAmountChange: ({ target: { id, value } }: ChangeEvent<HTMLInputElement>) => {
        onChange(
          {
            [key(id)]: value,
          },
          type
        )
      },

      onExpirationChange: (formattedValue: string, _: string, id: string) => {
        onChange({ [key(id)]: formatUTCDate(formattedValue) }, type)
      },

      onContactInfoChange: ({ target: { id, value } }: ChangeEvent<HTMLInputElement>) => {
        // TODO: these handlers are fired multiple time whenever one of the field
        // it is associated with is updated. cc @dmitri / @kevinngao
        if (id && value) {
          onChange(
            {
              contactInfo: {
                ...contactInfo,
                [key(id)]: value,
              },
            },
            type
          )
        }
      },

      onRadioChange: ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
        onChange({ [key(name)]: value === DISPLAY.yes }, type)
      },

      onSelectChange: ({ value }: { value: string }, id: string) => {
        onChange(
          {
            [key(id)]: value,
          },
          type
        )
      },
    }),
    [type, onChange, contactInfo]
  )

export default useHandlers
